import { AdminUserPermissionsEnum } from '@/lib/enum';
import { LogOut, Settings, User } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { SecuredComponent } from '@/components/hoc';
import { googleLogout } from '@react-oauth/google';
import { useUserConnected } from '@/hooks';
import { notify } from '@/functions';
import routes from '@/lib/routes';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import {
	DropdownMenuSeparator,
	DropdownMenuTrigger,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuLabel,
	DropdownMenuItem,
	AvatarFallback,
	DropdownMenu,
	Avatar
} from '@/components/ui';

interface IState {
	isOpen: boolean;
}

const AppHeaderAvatarUser = () => {

	const { userConnected, setUserConnected } = useUserConnected();
	const [state, setState] = useState<IState>({ isOpen: false });
	const navigate = useNavigate();

	const signature = (`${userConnected?.name.split(' ')[0]?.[0]}${userConnected?.name.split(' ')[1]?.[0] ?? ''}`).toUpperCase();

	const logout = () => {
		setUserConnected(null);
		googleLogout();
		navigate(routes.nav.login);
		notify('Vous avez été déconnecté');
	};

	if (!userConnected) {
		return <></>;
	}

	const handleOnOpenChange = (open: boolean) => {
		setState(l => ({ ...l, isOpen: open }));
	};

	return (
		<DropdownMenu onOpenChange={handleOnOpenChange}>
			<DropdownMenuTrigger asChild>
				<Avatar className={cn(
					'cursor-pointer h-9 w-9',
					state.isOpen && 'border border-purple-700/35'
				)}>
					<AvatarFallback className={'bg-purple-200 text-purple-700 text-sm'}>
						{signature}
					</AvatarFallback>
				</Avatar>
			</DropdownMenuTrigger>
			<DropdownMenuContent side='bottom' align='end'>
				<DropdownMenuLabel className='flex flex-col space-y-1 pr-5'>
					<p className='text-sm font-medium leading-none'>
						{userConnected.name}
					</p>
					<p className='text-xs leading-none text-muted-foreground'>
						{userConnected.email}
					</p>
				</DropdownMenuLabel>
				<DropdownMenuSeparator />
				<DropdownMenuGroup>
					<Link to={routes.nav.users.single.getHref(userConnected._id)}>
						<DropdownMenuItem
							title='Accéder aux informations de votre profil.'
							className='cursor-pointer pr-2'>
							<User size={16} />
							<span>
								Profil
							</span>
						</DropdownMenuItem>
					</Link>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.SETTINGS]}>
						<Link to={routes.nav.settings.permissions.getHref()}>
							<DropdownMenuItem
								title='Accéder aux paramètres système.'
								className='cursor-pointer pr-2'>
								<Settings size={16} />
								<span>
									Paramètres
								</span>
							</DropdownMenuItem>
						</Link>
					</SecuredComponent>
					<DropdownMenuSeparator />
					<DropdownMenuItem
						title='Se déconnecter de la plate forme.'
						onClick={logout}
						className={cn(
							'cursor-pointer bg-purple-100 text-purple-700 pr-5',
							' hover:bg-purple-50'
						)}>
						<LogOut size={16} />
						<span>
							Se déconnecter
						</span>
					</DropdownMenuItem>
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);

};

export default AppHeaderAvatarUser;
